// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2K5_o","resendInfoText":"OnGoingPaymentBox_resendInfoText__3z5Be"};